// Import fadeIn animation from external module
import { fadeIn } from "@pernod-ricard-global-cms/jsanimations";
// Import debounce function from lodash library
import { debounce } from 'lodash';

// Function to resize navigation elements based on window size
const resizeNav = () => {
  // Get references to navigation elements
  const navFullscreen = document.querySelector("#nav-fullscreen");
  const navOverlay = document.querySelector("#nav-overlay");
  
  // Calculate window dimensions
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  // Set the nav height to fill the window
  navFullscreen.style.height = `${windowHeight}px`;

  // Set the circle radius to the length of the window diagonal
  const radius = Math.sqrt(windowHeight ** 2 + windowWidth ** 2);
  const diameter = radius * 2;

  // Apply calculated dimensions and positioning to the overlay
  navOverlay.style.width = `${diameter}px`;
  navOverlay.style.height = `${diameter}px`;
  navOverlay.style.marginTop = `-${radius}px`;
  navOverlay.style.marginLeft = `-${radius}px`;
};

// Function to toggle navigation overlay
const toggleNav = () => {
  // Get references to navigation and body elements
  const navToggle = document.querySelector("#nav-toggle");
  const navOverlay = document.querySelector("#nav-overlay");
  const navFullscreen = document.querySelector("#nav-fullscreen");
  const html = document.getElementsByTagName('html')[0];
  const body = document.body;

  // Add click event listener to the navigation toggle
  navToggle.addEventListener("click", () => {
    // Toggle classes to control appearance and behavior
    navToggle.classList.toggle("active");
    navOverlay.classList.toggle("open");
    navFullscreen.classList.toggle("open");
    html.classList.toggle("lockPage");
    body.classList.toggle("lockPage");
  });
};

// Create a debounced version of the resizeNav function
const debounceScreenSize = debounce(resizeNav, 300);

// Function to handle window resizing
const handleWindowResize = () => {
  // Add event listener to window resize event using the debounced function
  window.addEventListener("resize", debounceScreenSize);
  // Call the debounced function immediately to set initial dimensions
  debounceScreenSize();
};

// Export the main function
export default function siteHeaderJs(options = {}) {
  try {
    // Extract options if provided
    const { block } = options;

    // Apply fadeIn animation
    fadeIn(block);

    // Call functions to set up navigation and window resize handling
    toggleNav();
    handleWindowResize();

  } catch (error) {
    // Log any errors that occur during execution
    console.error(error);
  }
}
